import WarningModal from '@/views/components/Modals/WarningModal';
import { Card, Col, Form, Row, Tooltip } from 'antd';
import { Progress as CustomProgress } from 'antd';
import FormDatePicker from '../../../components/Inputs/FormDatePicker';
import FormInput from '../../../components/Inputs/FormInput';
import FormSelectBox from '../../../components/Inputs/FormSelectBox';
import FormTextArea from '../../../components/Inputs/FormTextArea';
import FormTimePicker from '../../../components/Inputs/FormTimePicker';
import SecondaryLabel from '../../../components/Labels/SecondaryLabel';
import AlertModal from '../../../components/Modals/AlertModal';
import CommonModal from '../../../components/Modals/CommonModal';
import ConfirmationModal from '../../../components/Modals/ConfirmationModal';
import Paper from '../../../components/Paper/Paper';

export default function StoreTrailerRequest({
  userType,
  trailerOptions,
  fullName,
  branchAddr1,
  nameLabel,
  formAddTrailerRequest,
  trlHidden,
  selectedTrailerPickValue,
  selectLocationID,
  partnerLocationOptions,
  commodityOptions,
  branchDesc,
  selectSpecialInstruction,
  selectLiveLoad,
  selectDoorType,
  handleChangeEmpty,
  handleChangeLoaded,
  OpenRequestPopup,
  CloseModal,
  selectdeliveryCommodity,
  setLiveLoadUnloadHour,
  selectProduct,
  selectCommodity,
  setSupplierPhone,
  setProdWeight,
  setProdDimension,
  selectRequestTime,
  selectRequestDate,
  selectTrailerName,
  handleAlertClose,
  handleAlertOk,
  SaveTrailerRequest,
  locationLabel,
  addressLabel,
  phoneLabel,
  pickupTimeLabel,
  pickupDateLabel,
  selectedTrailerDoorValue,
  selectedLoadValue,
  liveLoadHoursOptions,
  trailerName,
  deliveryTime,
  branchBusPhone,
  rscm,
  scs,
  newErrorAlert,
  errorMessage,
  alertOpen,
  alertMessage,
  onConfirmFunc,
  isLoadedPickUp,
  isEmptyPickUp,
  isLoadedDelivered,
  hidden,
  deliveryDate,
  estimatedDimension,
  isLiveLoad,
  setHidden,
  selectDeliveryTime,
  selectDeliveryDate,
  trailerSizeOptions,
  selectTrailerSize,
  selectedValue,
  selectDelivered,
  checked1,
  handleChangeMultiStopY,
  handleChangeMultiStopN,
  selectStop1,
  stop1,
  selectStop2,
  stop2,
  selectStop3,
  stop3,
  deliveryTimeOptions,
  loadTrailer,
  warningModal,
  setWarningModal,
  warning,
  districtManager,
  percentage,
  progressBarColor,
}) {
  return (
    <>
      <Row gutter={20}>
        <Col sm={24}>
          <span className="pull-right color-1">
            {' '}
            <strong> {userType} </strong> Logged In{' '}
          </span>
        </Col>
      </Row>

      <div className="h-100 pb-15">
        <Row className="flex-direction-column flex-nowrap  h-100 ">
          <Col className="flex-1 custom-scroll-bar">
            <ConfirmationModal
              title="Alert"
              open={newErrorAlert}
              description={errorMessage}
              onOk={onConfirmFunc}
              onClose={onConfirmFunc}
              onCancel={onConfirmFunc}
              cancelButton
              okText="Ok"
              okButtonVariant="error"
            />
            <AlertModal
              title="Alert"
              open={alertOpen}
              description={alertMessage}
              onOk={handleAlertOk}
              onClose={handleAlertClose}
            />
            <WarningModal
              alertTitle="Warning"
              open={warningModal}
              description={warning}
              onClose={() => setWarningModal(false)}
              onOk={() => setWarningModal(false)}
            />
            <Form form={formAddTrailerRequest}>
              <div className="pb-5">
                <Paper className="mb-10 trailer-request-top-paper">
                  <div className="p-10">
                    <Row gutter={15}>
                      <Col
                        sm={4}
                        className="px-10"
                        style={{
                          borderRight: '5px solid #00557d26',
                          minHeight: '50vh',
                        }}
                      >
                        <div className="text-center mb-2">
                          <SecondaryLabel className="f-14">
                            {' '}
                            <u>Requester Details</u>{' '}
                          </SecondaryLabel>
                        </div>

                        <Row gutter={15}>
                          <Col sm={24}>
                            <FormInput
                              name="txtfullname"
                              label={nameLabel}
                              margin="m-0"
                              editMode
                              value={fullName}
                              placeholder="Auto populated value"
                              defaultValue={fullName}
                            />
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && userType !== 'Supplier' && (
                              <FormInput
                                name="districtManager"
                                label="District Manager"
                                margin="m-0"
                                editMode
                                value={districtManager}
                                placeholder="SCS"
                                defaultValue={districtManager}
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && userType !== 'Supplier' && (
                              <FormInput
                                name="txtscs"
                                label="SCS"
                                margin="m-0"
                                editMode
                                value={scs}
                                placeholder="SCS"
                                defaultValue={scs}
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && userType !== 'Supplier' && (
                              <FormInput
                                name="txtrscm"
                                label="RSCM"
                                margin="m-0"
                                editMode
                                value={rscm}
                                placeholder="Auto populated value"
                                defaultValue={rscm}
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && (
                              <FormSelectBox
                                label={locationLabel}
                                editMode
                                id="selPartnerLocation"
                                name="PartnerLocation"
                                margin="m-0"
                                options={partnerLocationOptions}
                                placeholder="Select Partner Location"
                                onChange={selectLocationID}
                                defaultValue={branchDesc}
                                disabled
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && (
                              <FormInput
                                name="txtaddr1"
                                label={addressLabel}
                                margin="m-0"
                                editMode
                                value={branchAddr1}
                                placeholder="Auto populated value"
                                defaultValue={branchAddr1}
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && (
                              <FormInput
                                name="txtphone"
                                label={phoneLabel}
                                margin="m-0"
                                editMode
                                value={branchBusPhone}
                                placeholder="Phone Number"
                                defaultValue={branchBusPhone}
                                readOnly={userType !== 'Supplier'}
                                rules={[
                                  {
                                    pattern: /^[0-9+ -]*$/,
                                    message: 'Please enter a valid phone number (only numbers, +, and - are allowed)',
                                  },
                                ]}
                                onChange={setSupplierPhone}
                              />
                            )}
                          </Col>
                        </Row>
                      </Col>

                      <Col sm={20} className="px-10">
                        <Card title="Pickup" headStyle={{ textAlign: 'center' }} className="mb-4" bordered>
                          <Row gutter={15}>
                            <Col sm={16}>
                              <Row gutter={15} className="mb-5">
                                <Col sm={9}>
                                  <SecondaryLabel className="f-12">We need a trailer picked up:</SecondaryLabel>
                                </Col>

                                <Col sm={15}>
                                  <Row gutter={15}>
                                    <Col>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="pickLoaded"
                                        checked={selectedTrailerPickValue === 'Loaded'}
                                        id="pickLoaded"
                                        value="Loaded"
                                        onClick={handleChangeLoaded}
                                      />
                                      <SecondaryLabel className="f-12"> Loaded </SecondaryLabel>
                                    </Col>
                                    {userType !== 'Supplier' && (
                                      <Col>
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="pickEmpty"
                                          checked={selectedTrailerPickValue === 'Empty'}
                                          id="pickEmpty"
                                          value="Empty"
                                          onClick={handleChangeEmpty}
                                        />
                                        <SecondaryLabel className="f-12"> Empty </SecondaryLabel>
                                      </Col>
                                    )}
                                    <Col>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="pickNone"
                                        checked={selectedTrailerPickValue === 'None'}
                                        id="pickNone"
                                        value="None"
                                        onClick={handleChangeEmpty}
                                      />
                                      <SecondaryLabel className="f-12"> None of the above </SecondaryLabel>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              <Row gutter={15}>
                                <Col sm={4} hidden={trlHidden}>
                                  <FormSelectBox
                                    label="Trailer Number"
                                    editMode
                                    id="selTrailerName"
                                    name="trailerName"
                                    margin="m-0"
                                    loading={loadTrailer}
                                    options={trailerOptions}
                                    placeholder="Select Trailer"
                                    onChange={selectTrailerName}
                                  />
                                </Col>
                                <Col sm={4}>
                                  <FormSelectBox
                                    label="Trailer Size"
                                    editMode
                                    name="trailerSize"
                                    margin="m-0"
                                    options={trailerSizeOptions}
                                    placeholder="Trailer Size"
                                    onChange={selectTrailerSize}
                                    disabled
                                  />
                                </Col>

                                <Col sm={4}>
                                  <FormDatePicker
                                    label={pickupDateLabel}
                                    name="trailerDate"
                                    margin="m-0"
                                    onChange={selectRequestDate}
                                    allowClear={false}
                                  />
                                </Col>

                                <Col sm={4}>
                                  <FormTimePicker
                                    label={pickupTimeLabel}
                                    editMode
                                    name="selectPickupTime"
                                    margin="m-0"
                                    onChange={selectRequestTime}
                                    use12Hours
                                    minuteStep={30}
                                  />
                                </Col>

                                <Col sm={4}>
                                  <FormSelectBox
                                    label="Pickup Location"
                                    editMode
                                    id="pickupLocation"
                                    name="pickupLocation"
                                    margin="m-0"
                                    disabled
                                    options={partnerLocationOptions}
                                    placeholder="Pickup Location"
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          {(isLoadedPickUp || isEmptyPickUp) && (
                            <Row gutter={15} className="mt-5">
                              <Col sm={18}>
                                <Row gutter={15}>
                                  <Col sm={6}>
                                    <FormSelectBox
                                      label="Commodity:"
                                      editMode
                                      name="Commodity"
                                      margin="m-0"
                                      options={commodityOptions}
                                      placeholder="Commodity"
                                      onChange={selectCommodity}
                                    />
                                    <div id="errorCommodity" className="text-danger" />
                                  </Col>
                                  {isLoadedPickUp && (
                                    <Col sm={18}>
                                      {userType !== 'Supplier' && (
                                        <div className="main-table-text" style={{ height: '70px' }}>
                                          <div className="react-bootstrap-table">
                                            <table className="w-100 table">
                                              <thead>
                                                <tr className="table-top">
                                                  <th className="center-align">
                                                    <SecondaryLabel className="f-12 text-white">
                                                      {' '}
                                                      Product Type{' '}
                                                    </SecondaryLabel>
                                                  </th>
                                                  <th className="center-align ">
                                                    <SecondaryLabel className="f-12 text-white">
                                                      {' '}
                                                      Estimated Weight{' '}
                                                    </SecondaryLabel>
                                                  </th>
                                                  <th className="center-align">
                                                    <SecondaryLabel className="f-12 text-white">
                                                      {' '}
                                                      Estimated Linear Feet{' '}
                                                    </SecondaryLabel>
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr>
                                                  <td className="center-align">
                                                    <input type="text" id="txtProdType" onChange={selectProduct} />
                                                  </td>

                                                  <td className="center-align">
                                                    <input type="number" id="txtProdWeight" onKeyUp={setProdWeight} />
                                                  </td>

                                                  <td className="center-align">
                                                    <input
                                                      disabled
                                                      id="txtProdDimension"
                                                      onKeyUp={setProdDimension}
                                                      value={estimatedDimension}
                                                    />
                                                  </td>
                                                </tr>
                                                <div id="errorWeight" className="text-danger" />
                                                <div id="errorDimension" className="text-danger" />
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      )}
                                    </Col>
                                  )}
                                </Row>
                              </Col>

                              {isLoadedPickUp && (
                                <Col sm={6}>
                                  <div className="progress-container">
                                    <div className="text-center" style={{ color: progressBarColor }}>
                                      {percentage.toFixed(1)}% utilized
                                    </div>
                                    <CustomProgress
                                      percent={percentage}
                                      size={[280, 25]}
                                      strokeLinecap="butt"
                                      strokeColor={progressBarColor}
                                      showInfo={false}
                                    />
                                  </div>
                                </Col>
                              )}
                            </Row>
                          )}
                        </Card>
                        <Card title="Delivery" headStyle={{ textAlign: 'center' }} className="mb-4" bordered>
                          <Row gutter={20} className="mt-5">
                            <Col sm={16}>
                              <Row gutter={15}>
                                <Col sm={9}>
                                  <SecondaryLabel className="f-12"> We need a trailer delivered: </SecondaryLabel>
                                </Col>
                                <Col sm={15}>
                                  <Row gutter={15}>
                                    {userType !== 'Supplier' && (
                                      <Col>
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="deliveryLoaded"
                                          checked={selectedValue === 'Loaded'}
                                          id="Loaded"
                                          value="Loaded"
                                          onClick={selectDelivered}
                                        />
                                        <SecondaryLabel className="f-12"> Loaded </SecondaryLabel>
                                      </Col>
                                    )}
                                    <Col>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="deliveryEmpty"
                                        checked={selectedValue === 'Empty'}
                                        id="Empty"
                                        value="Empty"
                                        onClick={selectDelivered}
                                      />
                                      <SecondaryLabel className="f-12"> Empty </SecondaryLabel>
                                    </Col>

                                    <Col>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="deliveryNone"
                                        checked={selectedValue === 'None'}
                                        id="None"
                                        value="None"
                                        onClick={selectDelivered}
                                      />
                                      <SecondaryLabel className="f-12"> None of the above </SecondaryLabel>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row gutter={10} className="mt-5">
                                <Col sm={6}>
                                  <FormDatePicker
                                    label="Delivery Date "
                                    name="deliveryDate"
                                    margin="m-0"
                                    value={new Date()}
                                    onChange={selectDeliveryDate}
                                    allowClear={false}
                                    disabledTargetDate={new Date()}
                                    disableFuture={false}
                                  />
                                </Col>

                                <Col sm={6}>
                                  <SecondaryLabel className="f-12 text-black"> Delivery Time </SecondaryLabel>
                                  <FormSelectBox
                                    editMode
                                    className="mt-2 w-100"
                                    name="selectDeliveryTime"
                                    margin="m-0"
                                    onChange={selectDeliveryTime}
                                    placeholder="Delivery Location"
                                    options={deliveryTimeOptions}
                                  />
                                </Col>
                                <Col sm={6}>
                                  <FormSelectBox
                                    label="Delivery Location"
                                    editMode
                                    id="locationID"
                                    name="deliveryLocation"
                                    margin="m-0"
                                    disabled
                                    placeholder="Delivery Location"
                                    options={partnerLocationOptions}
                                  />
                                </Col>
                              </Row>
                            </Col>

                            <Col sm={8}>
                              <Row gutter={15}>
                                <Col sm={24}>
                                  {userType !== 'Supplier' && (
                                    <Row gutter={20} className="mt-5">
                                      <Col sm={12}>
                                        <SecondaryLabel className="f-12">
                                          {' '}
                                          Multiple Stops needed for this trailer?:{' '}
                                        </SecondaryLabel>
                                      </Col>
                                      <Col sm={8}>
                                        <Row gutter={15}>
                                          <Col sm={12}>
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value="option1"
                                              checked={checked1}
                                              onChange={handleChangeMultiStopY}
                                            />
                                            <SecondaryLabel className="f-12">Yes</SecondaryLabel>
                                          </Col>
                                          <Col sm={12}>
                                            <input
                                              className="form-check-input"
                                              checked={checked1 === false}
                                              type="checkbox"
                                              value="option2"
                                              onChange={handleChangeMultiStopN}
                                            />
                                            <SecondaryLabel className="f-12"> No </SecondaryLabel>
                                          </Col>
                                          <div id="errorMultiStop" className="text-danger" />
                                        </Row>
                                      </Col>
                                    </Row>
                                  )}
                                  {checked1 && (
                                    <Row gutter={15}>
                                      <Col sm={8}>
                                        <FormSelectBox
                                          label="Stop 1"
                                          editMode
                                          id="stop1"
                                          name="stop1"
                                          margin="m-0"
                                          options={partnerLocationOptions}
                                          placeholder="Select 1st Stop"
                                          onChange={selectStop1}
                                          value={stop1}
                                        />

                                        <div id="errorStop1" className="text-danger" />
                                      </Col>

                                      <Col sm={8}>
                                        <FormSelectBox
                                          label="Stop 2"
                                          editMode
                                          id="stop2"
                                          name="stop2"
                                          margin="m-0"
                                          options={partnerLocationOptions}
                                          placeholder="Select 2nd Stop"
                                          onChange={selectStop2}
                                          value={stop2}
                                        />
                                      </Col>

                                      <Col sm={8}>
                                        <FormSelectBox
                                          label="Stop 3"
                                          editMode
                                          id="stop3"
                                          name="stop3"
                                          margin="m-0"
                                          options={partnerLocationOptions}
                                          placeholder="Select 3rd Stop"
                                          onChange={selectStop3}
                                          value={stop3}
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          {isLoadedDelivered && (
                            <Row gutter={20} className="mt-5">
                              <Col sm={18}>
                                <Row gutter={20} className="mb-2">
                                  <Col sm={6}>
                                    <FormSelectBox
                                      label="Commodity:"
                                      editMode
                                      name="Commodity1"
                                      margin="m-0"
                                      options={commodityOptions}
                                      placeholder="Commodity"
                                      onChange={selectdeliveryCommodity}
                                    />
                                    <div id="errorDelCommodity" className="text-danger" />
                                  </Col>
                                </Row>
                              </Col>

                              <Col sm={6}>
                                <div className="p-10 mt-2 background-danger-1" hidden>
                                  <SecondaryLabel className="f-12 text-white">
                                    {' '}
                                    Trailer # 25468 is 90% consumed{' '}
                                  </SecondaryLabel>
                                </div>
                              </Col>
                            </Row>
                          )}
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </Paper>

                <CommonModal
                  className="w-35 h-60"
                  open={hidden}
                  title="Items Details"
                  onClose={() => setHidden(false)}
                  customFooter={<></>}
                >
                  <div className="popup-body p-10">
                    <p className="h6 mb-15">
                      {' '}
                      Before you submit your trailer request, please review the details below to ensure accuracy.
                    </p>

                    <div className="mb-40">
                      <Row gutter={15} className="mb-10">
                        <Col sm={8}>
                          <label htmlFor="">Trailer #: </label>
                        </Col>
                        <Col>
                          <span>{trailerName}</span>
                        </Col>
                      </Row>

                      <Row gutter={15} className="mb-10">
                        <Col sm={8}>
                          <label htmlFor="">Date Trailer Requested: </label>
                        </Col>
                        <Col>
                          <span>{deliveryDate?.split('T')[0]}</span>
                        </Col>
                      </Row>
                      {deliveryTime && (
                        <Row gutter={15} className="mb-10">
                          <Col sm={8}>
                            <label htmlFor="">Time Trailer Requested: </label>
                          </Col>
                          <Col>
                            <span>{deliveryTime}</span>
                          </Col>
                        </Row>
                      )}
                    </div>
                    <div className="text-center" style={{ marginTop: '80px' }}>
                      <button type="button" className="btn btn-dipblue mr-5" onClick={SaveTrailerRequest}>
                        {' '}
                        Proceed{' '}
                      </button>
                      <button type="button" className="btn btn-dipblue" onClick={CloseModal}>
                        {' '}
                        Cancel{' '}
                      </button>
                    </div>
                  </div>
                </CommonModal>

                <Paper>
                  <div className="card-header p-8">
                    <SecondaryLabel className="f-14 text-white"> Special Instructions </SecondaryLabel>
                  </div>

                  <div className="p-10">
                    <Row gutter={15}>
                      <Col sm={14}>
                        <Row gutter={20} className="mb-5">
                          <Col sm={4}>
                            <SecondaryLabel className="f-12"> Trailer Door Type: </SecondaryLabel>
                          </Col>

                          <Col sm={20}>
                            <Row gutter={15}>
                              <Col>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  checked={selectedTrailerDoorValue === 'Swingdoor'}
                                  name="trlSwingdoor"
                                  id="Swingdoor"
                                  value="SWNGDR"
                                  onClick={selectDoorType}
                                />
                                <SecondaryLabel className="f-12"> Swing door </SecondaryLabel>
                              </Col>

                              <Col>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  checked={selectedTrailerDoorValue === 'RollUpdoor'}
                                  name="trlRollUpdoor"
                                  id="RollUpdoor"
                                  value="RLLUPDR"
                                  onClick={selectDoorType}
                                />
                                <SecondaryLabel className="f-12"> Roll door </SecondaryLabel>
                              </Col>
                              <div id="errorTrailerDoor" className="text-danger" />
                            </Row>
                          </Col>
                        </Row>

                        <Row gutter={20} className="mb-2">
                          <Col sm={8}>
                            <Row gutter={15}>
                              <Col sm={12}>
                                <SecondaryLabel className="f-12"> Live Load / Unload: </SecondaryLabel>
                              </Col>
                              <Col sm={12}>
                                <Row gutter={15}>
                                  <Col>
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="rbLoad"
                                      checked={selectedLoadValue === 'Load'}
                                      id="Load"
                                      value="Yes"
                                      onClick={selectLiveLoad}
                                    />
                                    <SecondaryLabel className="f-12"> Yes </SecondaryLabel>
                                  </Col>

                                  <Col>
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="rbUnload"
                                      checked={selectedLoadValue === 'UnLoad'}
                                      id="Unload"
                                      value="No"
                                      onClick={selectLiveLoad}
                                    />
                                    <SecondaryLabel className="f-12"> No </SecondaryLabel>
                                  </Col>
                                  <div id="errorLiveLoad" className="text-danger" />
                                </Row>
                              </Col>
                            </Row>
                          </Col>

                          <Col sm={6}>
                            {isLiveLoad && (
                              <FormSelectBox
                                label={
                                  <Tooltip title="Driver stays on site while loading/unloading 1-4 hours max.">
                                    Live Load / Unload Hours:
                                  </Tooltip>
                                }
                                editMode
                                name="LiveLoadHours"
                                margin="m-0"
                                options={liveLoadHoursOptions}
                                placeholder="Live Load/Unload Hours"
                                onChange={setLiveLoadUnloadHour}
                              />
                            )}
                          </Col>
                        </Row>
                      </Col>

                      <Col sm={10}>
                        <FormTextArea
                          editMode
                          name="txtSpecialInstruct"
                          margin="mb-14"
                          placeholder="Special Instructions"
                          enableAutoFocus={false}
                          rows={3}
                          onChange={selectSpecialInstruction}
                        />

                        <div className="text-center">
                          <button type="button" className="btn btn-dipblue me-5" onClick={OpenRequestPopup}>
                            {' '}
                            Submit Request{' '}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Paper>
              </div>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
}
